import { UpperCasePipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CountryMenuComponent } from '@warema/shared/country';
import { IAppConfig } from '@warema/shared/models';
import { WaremaHeaderMenuItem } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-shared-header-submenu-language',
    imports: [TranslatePipe, UpperCasePipe, CountryMenuComponent, WaremaHeaderMenuItem],
    templateUrl: './shared-header-submenu-language.component.html',
    styleUrl: './shared-header-submenu-language.component.scss',
})
export class SharedHeaderSubmenuLanguageComponent {
    public readonly translateService = inject(TranslateService);

    public readonly isLoggedIn = input.required<boolean>();

    public readonly tenantConfigSettings = input<IAppConfig | null>(null);

    public readonly appName = input.required<'warema-collection-assistant' | 'warema-designer-web' | 'warema-plus'>();

    public readonly showCountryMenu = input(true);

    public readonly setLanguage = output<string>();
}
